export enum ProjectCostCodeType {
  CostCode = 1, 
  SumCostCode = 2
}
    
export enum MissingCostCodeValidationLevel {
  Nothing = 0,
  Warning = 1,
  Block = 2
}